export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-hamish-c19effe3f1b57fdd613b34db8c917c7a.jpg";